import React from 'react';
import { useStoreContext } from '../../Contexts/StoreContext';
import { useOrderTypeContext } from '../../Contexts/OrderTypeContext';
import Button from '../Form/Button';
import { ORDER_TYPE_ICONS, ORDER_TYPE_LABELS } from '../../Utils/Constants/Service';
import { formatCurrentAddress } from '../../Utils/Formatters';
import { TbCaretDownFilled, TbClock, TbMapPin } from 'react-icons/tb';
import { useLayoutContext } from '../../Contexts/LayoutContext';
import { useTranslation } from 'react-i18next';
import { isLongOrderTypeLabel } from '../../Utils/Helpers';

interface BoxContentStoreOrderTypeHeaderProps {
    sizeButton?: number;
}

const BoxContentStoreOrderTypeHeader = ({ sizeButton }: BoxContentStoreOrderTypeHeaderProps) => {

    const { t } = useTranslation();
    const { currentStore, checkStoreOpen, currentAddress, cashier } = useStoreContext();
    const { orderType, getOrderTypeIdByName, isDelivery, isDinein, isStoreCounter, isMenu } = useOrderTypeContext();
    const { setShowStart } = useLayoutContext();
    const IconOrderType = ORDER_TYPE_ICONS[orderType as keyof typeof ORDER_TYPE_ICONS];
    const isStoreClosed = orderType && !checkStoreOpen(Number(getOrderTypeIdByName(orderType)))

    return (
        <div className="flex items-center w-full md:w-auto h-full gap-4 text-gray-500">
            <div className={`grid w-full gap-1 text-right ${isDelivery && 'cursor-pointer'}`} onClick={() => isDelivery ? setShowStart(true) : {}}>

                {/* Current Address */}
                {isDelivery &&
                    <div className="flex gap-0.5 text-xs font-bold leading-none text-shopfood-title justify-end">
                        <div className="line-clamp-1 min-w-36">{ currentAddress ? formatCurrentAddress(currentAddress, true) : t('header.current_address_not_selected_label') }</div>
                        <div className="-mr-0.5"><TbCaretDownFilled className='text-custom-primary leading-none' /></div>
                    </div>
                }

                <div className="flex w-full gap-0.5 flex-col leading-none">

                    {/* Store name */}
                    {currentStore &&
                        <div className="flex w-full gap-0.5 justify-end">
                            <div className={`${isDelivery ? "" : "text-shopfood-title font-bold"} text-xs leading-tight line-clamp-1`}>{currentStore?.name}</div>
                            {!isDelivery && <div className="-mr-1 -mt-0.5 self-start"><TbMapPin className='text-gray-500 leading-none' /></div>}
                        </div>
                    }

                    {/* Neighborhood */}
                    {currentStore?.neighborhood && !isDelivery && <div className='text-xs leading-tight line-clamp-1 md:min-w-28'>{currentStore.neighborhood}</div>}

                    {/* Store closed or shipping time */}
                    {isStoreClosed 
                        ?   <div className='flex items-center justify-end gap-0.5 -me-0.5 text-nowrap leading-none text-xs text-gray-500'>
                                {t('layout.store_closed_label')}
                                <TbClock />
                            </div>
                        :   ((isDelivery || isDinein) && currentStore && currentStore.shipping_time && currentStore.shipping_time > 0) &&
                                <div className='flex items-center justify-end gap-0.5 -me-0.5 text-nowrap leading-none text-xs text-gray-500'>
                                    {currentStore.shipping_time} {t('header.shipping_time.minutes')}
                                    <TbClock />
                                </div>
                    }
                </div>

            </div>

            {orderType && ((!isStoreCounter && !isMenu) || (isStoreCounter && cashier && currentStore.customer_self_attendance)) &&
                <Button
                    onClick={() => {
                        React.startTransition(() => {
                            setShowStart(true);
                        });
                    }}
                    disabled={isStoreCounter}
                    className="rounded-md aspect-square flex-col px-[0.5em] h-16 text-shopfood-title disabled:bg-gray-100 disabled:ring-transparent">
                    <div>
                        <IconOrderType size={isLongOrderTypeLabel(orderType) ? 18 : sizeButton} />
                    </div>
                    <span className={`leading-none ${isLongOrderTypeLabel(orderType) ? 'text-[10px]' : 'text-xs'}`}>
                        {ORDER_TYPE_LABELS[orderType as keyof typeof ORDER_TYPE_LABELS]}
                    </span>
                </Button>
            }
        </div>
    );
};

export default BoxContentStoreOrderTypeHeader;
